import { useEffect } from 'react';
import api, { saveSessionToken } from '@/utils/api';
import { captureMetaClickIds } from '@/utils/metaAttribution';

/**
 * If the user has a valid session cookie (e.g. from a previous visit) but no
 * Bearer token in localStorage, sync the token once so API calls work when
 * third-party cookies to the API host are blocked.
 */
export default function SessionBootstrap() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Meta's ?fbclid= lives only on the landing URL — capture it here, before
    // any navigation drops it, or the ad click can never be tied to the signup.
    captureMetaClickIds();

    // Capture UTM parameters from URL if present
    const params = new URLSearchParams(window.location.search);
    const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
    const utmData = {};
    let hasUtm = false;

    utmKeys.forEach((key) => {
      const value = params.get(key);
      if (value) {
        utmData[key] = value;
        hasUtm = true;
      }
    });

    if (hasUtm) {
      try {
        localStorage.setItem('utm_data', JSON.stringify(utmData));
      } catch (e) {
        console.error('Failed to save UTM parameters to localStorage:', e);
      }
    }

    if (localStorage.getItem('session_token')) return;
    let cancelled = false;
    api
      .get('/api/auth/session-token')
      .then((res) => {
        if (!cancelled && res.data?.token) saveSessionToken(res.data);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, []);
  return null;
}
